import React, { FC } from 'react';
import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { THEME as theme } from '../../../../styles/theme';
import PageCount from '../../components/PageCount/PageCount';
import PageSection from '../../components/PageSection/PageSection';

const styles = StyleSheet.create({
  page: {
    position: 'relative',
    fontFamily: 'Roboto-Regular',
    backgroundColor: theme.colors.neutral.secondary,
  },
  section: { margin: 10, padding: 10 },
  header: { fontSize: 14, fontWeight: 'bold' },
  body: { fontSize: 12, marginTop: 5 },
  boldText: { fontFamily: 'Roboto-Bold', fontWeight: 700, fontSize: 10 },
  paragraph: { marginTop: 10 },
  normalText: { fontSize: 10 },
});

const processText = (inputText: string) => {
  const elements: React.ReactNode[] = [];

  const lines = inputText.split(/<br\s*\/?>/);

  lines.forEach((line, lineIndex) => {
    const parts = line.split(/(<b>.*?<\/b>)/g);

    elements.push(
      <Text key={`line-${lineIndex}`} style={lineIndex === 0 ? styles.header : styles.body}>
        {parts.map((part, index) => {
          if (part.startsWith('<b>') && part.endsWith('</b>')) {
            return (
              <Text key={`bold-${index}`} style={styles.boldText}>
                {part.slice(3, -4)}
              </Text>
            );
          } else {
            return (
              <Text key={`normal-${index}`} style={styles.normalText}>
                {part}
              </Text>
            );
          }
        })}
      </Text>
    );

    if (lineIndex < lines.length - 1) {
      elements.push(
        <Text key={`line-break-${lineIndex}`} style={styles.normalText}>
          {'\n'}
        </Text>
      );
    }
  });

  return elements;
};

interface IKeyTakeawaysPage {
  keyTakeaways: string;
}

const KeyTakeawaysPage: FC<IKeyTakeawaysPage> = ({ keyTakeaways }) => {
  const { t } = useTranslation();

  return (
    <Page id="summary" orientation="portrait" size="A4" style={styles.page} wrap={false}>
      <PageSection title={t('results.report.pdf.sections.summary')}>
        <View style={styles.section}>{processText(keyTakeaways)}</View>
      </PageSection>
      <PageCount />
    </Page>
  );
};

export default KeyTakeawaysPage;
